<script setup>
import LoginScreen from '../components/LoginScreen.vue';
</script>

<template>
  <div class="register">
    <div class="mx-auto max-w-6xl">
      <div class="flex flex-wrap justify-between" >
        <div class="w-4/12">
          <h1 class="separator-center mb-2 leading-normal text-2xl">Login</h1>
        </div>
        <div class="w-4/12"><RouterLink class="btn btn-primary float-right" to="/">Back to Home</RouterLink></div>
      </div>
        
        
      </div>
      <LoginScreen></LoginScreen>

  </div>
</template>